/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormEventModel
 */
export interface FormEventModel {
    /**
     * 
     * @type {string}
     * @memberof FormEventModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FormEventModel
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof FormEventModel
     */
    action: FormEventModelActionEnum;
    /**
     * 
     * @type {string}
     * @memberof FormEventModel
     */
    label: string;
}


/**
 * @export
 */
export const FormEventModelActionEnum = {
    Impression: 'impression',
    Error: 'error'
} as const;
export type FormEventModelActionEnum = typeof FormEventModelActionEnum[keyof typeof FormEventModelActionEnum];


/**
 * Check if a given object implements the FormEventModel interface.
 */
export function instanceOfFormEventModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function FormEventModelFromJSON(json: any): FormEventModel {
    return FormEventModelFromJSONTyped(json, false);
}

export function FormEventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormEventModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'category': json['category'],
        'action': json['action'],
        'label': json['label'],
    };
}

export function FormEventModelToJSON(value?: FormEventModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'category': value.category,
        'action': value.action,
        'label': value.label,
    };
}

